module.exports = __webpack_public_path__ + "media/images/illustration_6-c919084258f001d940b4ec7fbb157724.png";